// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/assistantInfo';
import model_2 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/auth';
import model_3 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/chuangkit';
import model_8 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/planDetailsState';
import model_5 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/hotspot';
import model_9 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/planInfo';
import model_10 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/publicApi';
import model_6 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/marketingCalendar';
import model_11 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/VisualizeData';
import model_12 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/pages/AssistantInfo/models/assistantInfo';
import model_7 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/myPlan';
import model_13 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/pages/AssistantInfo/models/createPlan';
import model_15 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/pages/AssistantInfo/models/wpsKnowledge';
import model_16 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/pages/AssistantManagement/models/assistantManagement';
import model_17 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/.umi-production/plugin-initialState/@@initialState';
import model_4 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/models/global';
import model_14 from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/src/pages/AssistantInfo/models/knowledgeBase';

export const models = {
model_1: { namespace: 'assistantInfo', model: model_1 },
model_2: { namespace: 'auth', model: model_2 },
model_3: { namespace: 'chuangkit', model: model_3 },
model_8: { namespace: 'planDetailsState', model: model_8 },
model_5: { namespace: 'hotspot', model: model_5 },
model_9: { namespace: 'planInfo', model: model_9 },
model_10: { namespace: 'publicApi', model: model_10 },
model_6: { namespace: 'marketingCalendar', model: model_6 },
model_11: { namespace: 'VisualizeData', model: model_11 },
model_12: { namespace: 'AssistantInfo.assistantInfo', model: model_12 },
model_7: { namespace: 'myPlan', model: model_7 },
model_13: { namespace: 'AssistantInfo.createPlan', model: model_13 },
model_15: { namespace: 'AssistantInfo.wpsKnowledge', model: model_15 },
model_16: { namespace: 'AssistantManagement.assistantManagement', model: model_16 },
model_17: { namespace: '@@initialState', model: model_17 },
model_4: { namespace: 'global', model: model_4 },
model_14: { namespace: 'AssistantInfo.knowledgeBase', model: model_14 },
} as const
